const {

    REACT_APP_FLYER_SHOPPER_SERVER_ADDRESS,
    REACT_APP_DEVELOPMENT_MODE,
    REACT_APP_FLYER_EDITOR_SERVER_ADDRESS,
    REACT_APP_FLYER_APP_ADDREESS

} = process.env;

class EnvManager {
    developmentMode: string | undefined = REACT_APP_DEVELOPMENT_MODE;
    flyerEditorServerAddress: string | undefined = REACT_APP_FLYER_EDITOR_SERVER_ADDRESS;
    flyerShopperServerAddress: string | undefined = REACT_APP_FLYER_SHOPPER_SERVER_ADDRESS;
    flyerAppAddress: string | undefined = REACT_APP_FLYER_APP_ADDREESS;

    getFlyerAppAddressWithEnvPrefix(prefix: string) {
        // ex: https://dev.xcshopper.com
        let splitted = this.flyerAppAddress!.split('//')

        let https = splitted[0] + '//';
        let url_without_https = splitted[1]

        let finalUrl = https + prefix + '.'

        // [dev, xcshopper, com]
        let splitted2 = url_without_https.split('.')

        for (let i = 1; i < splitted2.length; i++) {
            const urlPart = splitted2[i];

            finalUrl += urlPart

            if (i < (splitted2.length - 1)) {
                finalUrl += '.'
            }
        }

        finalUrl += '/'

        if (prefix.length === 0) {
            // prod
            finalUrl = `${https}xcshopper.xcircular.com/`
        }


        //-------------------------------------------------//
        // FOR NOW HARD CORDED BY ENV:
        finalUrl = REACT_APP_FLYER_APP_ADDREESS! + "/";
        //-------------------------------------------------//

        return finalUrl;
    }
}

const envManager = new EnvManager();

export default envManager;